
export const HOURLY_RATE = "H"
export const CASE_RATE = "C"